import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { StoreContext } from 'store/context'
import { showNotificationBasedOnDevice, redirectToProfileWithNotification } from 'utils/notification-helper'

import ChangePasswordComponent from './component'

const { any, custom, string } = validators

const ChangePasswordContainer = combine({
	hooks: [
		withContext('appStore', StoreContext),
		withFormModel(
			{
				oldPassword: {
					alias: 'Old password',
					spec: spec.flow(string.isString, string.isNotEmpty, any.required),
				},

				newPassword: {
					alias: 'New password',
					spec: spec.flow(string.isString, string.isNotEmpty, any.required),
				},

				confirmation: spec.flow(
					string.isString,
					custom.matchProp({ key: 'newPassword', alias: 'New Password' }),
					string.isNotEmpty,
					any.required
				),
			},
			{ id: 'change-password' }
		),

		withCallbacks({
			onSubmit:
				({ appStore }) =>
					async (data) => {
						const isMobile = window.innerWidth <= 767

						try {
							const loggedEntity = appStore?.auth?.loggedEntity
							if (!loggedEntity) {
								if (isMobile) {
									// Mobile: Show notification and redirect to profile (top notification only)
									redirectToProfileWithNotification(null, 'error', 'Changes unsaved', true)
								} else {
									// Desktop: Show toaster notification only
									showNotificationBasedOnDevice('error', 'Changes unsaved')
								}
								return
							}

							await loggedEntity.changePassword(data.oldPassword, data.newPassword)

							if (isMobile) {
								// Mobile: Show notification and redirect to profile (top notification only)
								redirectToProfileWithNotification(null, 'success', null, true)
							} else {
								// Desktop: Show toaster notification only
								showNotificationBasedOnDevice('success')
							}

						} catch (error) {
							if (isMobile) {
								// Mobile: Show notification and redirect to profile (top notification only)
								redirectToProfileWithNotification(null, 'error', 'Changes unsaved', true)
							} else {
								// Desktop: Show toaster notification only
								showNotificationBasedOnDevice('error', 'Changes unsaved')
							}
						}
					},
		}),
	],

	transformProps: ({ appStore, form, onSubmit }) => ({
		form,
		onSubmit,
		isLoading: appStore?.loading || false,
	}),
})(ChangePasswordComponent)

export default ChangePasswordContainer 